import styled from 'styled-components';

import { variableFontRegular } from 'styles/theme/text';
import { ISize } from 'shared/types/Size';
import { t } from 'localization/utils/t';

const TP = 'productTemplate.components.buyBar.BuyBarItemDesktopNoStock';

interface IBuyBarItemDesktopNoStockProps {
  item?: ISize;
}

export const BuyBarItemDesktopNoStock = ({ item }: IBuyBarItemDesktopNoStockProps) => (
  <BuyBarItemDesktopNoStock.NoStock>
    <BuyBarItemDesktopNoStock.Size>{item?.presentation}</BuyBarItemDesktopNoStock.Size>
    <BuyBarItemDesktopNoStock.OutOfStock data-qa="buy_bar_oos">
      {t(`${TP}.outOfStock`, 'Currently Unavailable')}
    </BuyBarItemDesktopNoStock.OutOfStock>
  </BuyBarItemDesktopNoStock.NoStock>
);

BuyBarItemDesktopNoStock.NoStock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: ${({ theme }) => theme.breakpoints.small - 1}px) {
    color: ${({ theme }) => theme.colors.white};
  }
  &:hover > div:last-child {
    opacity: 1;
    width: 75px;
    text-align: center;
  }
`;

BuyBarItemDesktopNoStock.Size = styled.div`
  margin-bottom: 4px;
  text-transform: uppercase;

  @media (max-width: ${({ theme }) => theme.breakpoints.small - 1}px) {
    ${variableFontRegular({ height: '20px', size: '18px' })};
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.small}px) {
    ${variableFontRegular({ height: '14px', size: '11.5px' })};
  }
`;

BuyBarItemDesktopNoStock.OutOfStock = styled.div`
  opacity: 0;

  @media (max-width: ${({ theme }) => theme.breakpoints.small - 1}px) {
    ${variableFontRegular({ height: '16px', size: '11.5px' })};
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.small}px) {
    ${variableFontRegular({ height: '14px', size: '11.5px' })};
  }
`;
